module.exports = __webpack_public_path__ + "static/media/ic-alert.ce589575.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/ic-alert.svg
// module id = 740
// module chunks = 0